module.exports = __webpack_public_path__ + "static/media/iphone_11_pro_gold.85737c12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_11_pro_gold.png
// module id = 2066
// module chunks = 0